import { arrayToRecord } from './EmployeeList.helpers';
export const reducer = (state, { type, value }) => {
    switch (type) {
        case 'setStatus': {
            return {
                ...state,
                status: value,
            };
        }
        case 'setPage': {
            return {
                ...state,
                page: value,
            };
        }
        case 'setEmployees': {
            return {
                ...state,
                employees: value.items,
                totalCount: value.totalCount,
            };
        }
        case 'setSelectAll': {
            return {
                ...state,
                selectAll: value,
            };
        }
        case 'setSelectedEmployees': {
            return {
                ...state,
                selectedEmployees: value,
            };
        }
        case 'updateSelectedEmployees': {
            const filtered = value.filter(({ id }) => state.selectedEmployees[id]);
            return {
                ...state,
                selectedEmployees: { ...state.selectedEmployees, ...arrayToRecord(filtered) },
            };
        }
        case 'setSelectAllStatus': {
            return {
                ...state,
                selectAllStatus: value,
            };
        }
        case 'setEmploymentPeriodQuery': {
            return {
                ...state,
                employmentPeriodQuery: value,
            };
        }
        case 'setSearchQuery': {
            return {
                ...state,
                searchQuery: value,
            };
        }
        case 'setReferences': {
            return {
                ...state,
                references: value,
            };
        }
        case 'setEditEmployee': {
            return {
                ...state,
                editEmployee: value,
            };
        }
        case 'setReloadListFlag': {
            return {
                ...state,
                reloadListFlag: value,
            };
        }
        case 'setPreloadedEmployees': {
            return {
                ...state,
                preloadedEmployees: value,
            };
        }
    }
};
